export default "__VITE_ASSET__ByE$ot$O__"